export const SALES_ACTIVITY_CATEGORY_SELECTED =
  'sales_activity_category_selected';
export const SALES_ACTIVITY_EVENT_TYPE_SELECTED =
  'sales_activity_event_type_selected';
export const SALES_ACTIVITY_PROMOTOR_CHECKOUT =
  'sales_activity_promotor_checkout';
export const SALES_ACTIVITY_PROMOTOR_EXPORT = 'sales_activity_promotor_export';
export const SALES_ACTIVITY_GWP_TRACKER_PROMOTOR_EXPORT =
  'sales_activity_gwp_tracker_promotor_export';
